module.exports = __webpack_public_path__ + "static/media/bg-thankyou.e273a68e.png";